<template>
  <v-layout align-center>
    <v-flex>
      <v-subheader>{{title}}</v-subheader>
    </v-flex>
    <v-flex class="mr-2" shrink>
      <v-switch v-model="active" class="mt-0" hide-details label="Valores mapeados" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("valueMapping", ["showingMappedValues"]),
    active: {
      get() {
        return this.showingMappedItems;
      },
      set(val) {
        this.setShowingMappedValues(val);
      }
    },
    title() {
      return this.showingMappedValues
        ? `Mapeos`
        : `Valores sin mapear`;
    }
  },
  methods: {
    ...mapMutations("valueMapping", ["setShowingMappedValues"])
  }
};
</script>